import template from './template.html';
import './styles.css';

controller.$inject = ['$stateParams', '$scope', '$rootScope', 'ShiftsService', 'DateService', 'UserService', 'Alerts'];
function controller($stateParams, $scope, $rootScope, ShiftsService, DateService, UserService, Alerts) {
    let vm = {};    
    const minutesInAnHour = 60;
    const minuteAsPercentageOfDay = 80 / (24 * 60);
    const dayAsPercentageOfWeek = 100 / 7;
    const minimumShiftLengthMinutes = 15;
    const maximumShiftLengthMinutes = 12 * 60;
    this.$onInit = function() {
    vm = this;

    vm.week = DateService.getSundayForDate($stateParams.week);
    vm.newShift = {
        isOtherShift: true,
        storeId: $stateParams.storeId,
    };

    vm.addNewFormActive = false;
    vm.showValidationMessages = false;
    vm.showProcessingMessage = false;
    vm.hideCancelButton = false;
    vm.hideSaveButton = false;

    vm.addDaysToWeek = addDaysToWeek;
    vm.addMinutes = addMinutes;
    vm.minimumShiftLengthMinutes = minimumShiftLengthMinutes;
    vm.maximumShiftLengthMinutes = maximumShiftLengthMinutes;
    vm.getShiftStyle = getShiftStyle;
    vm.getFormattedTime = getFormattedTime;
    vm.addOtherShift = addOtherShift;
    vm.cancelAddOtherShift = cancelAddOtherShift;
    vm.processMessage = processMessage;
    vm.saveOtherShift = saveOtherShift;
    vm.deleteOtherShift = deleteOtherShift;
    vm.isInPast = DateService.dateIsPast;
    vm.weekEntirelyInPast = DateService.weekEntirelyInPast(vm.week);

    vm.userCanAdd = false;
    vm.userCanDelete = false;

    vm.formAlignment = 'middle';

    UserService.isInRole('AllocateDrivers').then(result => {
        vm.userCanAdd = result;
        vm.userCanDelete = result;
    });
}

    function addDaysToWeek(daysToAdd) {
        const d = new Date(vm.week);
        d.setDate(d.getDate() + parseInt(daysToAdd));
        return d;
    }

    function addMinutes(dateTime, minutesToAdd) {
        const dt = new Date(dateTime);
        dt.setMinutes(dt.getMinutes() + parseInt(minutesToAdd));
        return dt;
    }

    function getShiftStyle(shift) {
        let shiftDate = new Date(shift.date);
        let top = minuteAsPercentageOfDay * getMinutesFromTime(shift.startTime) + '%';
        let bottom = 100 - (minuteAsPercentageOfDay * getMinutesFromTime(shift.endTime)) + '%';
        let left = dayAsPercentageOfWeek * (shiftDate.getDay()) + '%';
        let right = 100 - (dayAsPercentageOfWeek * (shiftDate.getDay() + 1)) + '%';

        return {
            top,
            bottom,
            left,
            right
        };
    }

    function getMinutesFromTime(time) {
        time = time.toString();
        let minutes = parseInt(time.substring(time.length - 2));
        let hours = parseInt(time.substring(0, time.length - 2));
        return (hours * minutesInAnHour) + minutes;
    }

    function getFormattedTime(timeAsInt) {
        let result = timeAsInt.toString();
        result = '0' + result;
        result = result.substring(result.length - 4); //ensure four characters
        result = result.substring(0, 2) + ":" + result.substring(2);
        return result;
    }

    function addOtherShift() {
        vm.addNewFormActive = true;
        processMessage(false);
    }

    function cancelAddOtherShift() {
        vm.addNewFormActive = false;
        processMessage(false);
    }

    function saveOtherShift() {
            
        if ($scope.newShiftForm.$invalid) {
            vm.showValidationMessages = true;
            return;
        }

        let newShift = angular.copy(vm.newShift);

        newShift.driver = vm.driver.id;
        newShift.date = addDaysToWeek(newShift.dayOfWeek);
        newShift.startTime = DateService.timeAsInteger(newShift.startTime);
        newShift.endTime = DateService.timeAsInteger(newShift.endTime);
        processMessage(true);
        
        ShiftsService.postShift(newShift, driverIsOnHolidayOnShiftDate(newShift)).then(() => {
            processMessage(false);
            vm.addNewFormActive = false;
            $rootScope.$broadcast('other-shift-added');
        }, function (error) {
            processMessage(false);
            vm.addNewFormActive = false;
            Alerts.error(error);
        });
           
    }

    function driverIsOnHolidayOnShiftDate(shift) {
        for (let i = 0; i < vm.holidays.length; i++) {
            if (DateService.isSameDay(vm.holidays[i].day, shift.date)) return true;
        }
        return false;
    }

    function deleteOtherShift(shift) {
        Alerts.showConfirmDialog('Delete shift \'' + shift.description + '\'?', 'Yes, delete the shift', function () {
            ShiftsService.deleteOtherShift(shift).then(() => {
                $rootScope.$broadcast('other-shift-deleted');
                Alerts.showTimedSuccessMessage('Shift successfully deleted');
            }, function (error) {
                Alerts.error(error);
            });
        });
    }
    
    function processMessage(displayStatus) {
        vm.showProcessingMessage = displayStatus;
        vm.hideCancelButton = displayStatus;
        vm.hideSaveButton = displayStatus;
    }
    
}

export default () => ({
    template,
    controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {
        driver: '=',
        shifts: '=',
        holidays: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/planner/driverview/index.js